import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const collectionItemPositionSortOrder = [Order.asc(OrderKeys.position)];

export const collectionItemsSpecificSortOptions: OptionsDictionary = {
  'position': SortOptions.position,
  'dateAdded': SortOptions.dateAdded
};

export const collectionItemsMixedContentOptionsBase: OptionsDictionary = {
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
};
